import PageWrapper from "../../components/common/layout/PageWrapper";
import { useTranslation } from "react-i18next";
import useAppSelector from "../../../hooks/redux/base/useAppSelector";
import RegprofAdditionalDocNew from "../../components/services/additionalDoc/RegprofAdditionalDocNew";

const RegprofAdditionalDocNewPage = () => {
  const { t } = useTranslation();

  const selectedService = useAppSelector((state) => {
    return state.SelectedService;
  });

  return (
    <PageWrapper title={t(`${selectedService.titleCode}.new`)}>
      <RegprofAdditionalDocNew />
    </PageWrapper>
  );
};

export default RegprofAdditionalDocNewPage;
